import api from './axios';

const list = async () => {
  try {
    const { data } = await api.get('mcare-artemis-contract/contract');
    return data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    throw error.response.data ? error.response.data : error.response;
  }
};

const get = async (contractId) => {
  try {
    const { data } = await api.get(`mcare-artemis-contract/contract/${contractId}`);
    return data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    throw error.response.data ? error.response.data : error.response;
  }
};

const update = async (contract) => {
  try {
    const { data } = await api.put(
      `mcare-artemis-contract/contract/${contract.id}`,
      contract,
    );
    return data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    const { status } = error.response;
    const message = status === 400
      ? 'Verifique os campos obrigatórios'
      : 'Houve um problema ao salvar o contrato';
    throw new Error(message);
  }
};

export default {
  list,
  get,
  update,
};
